import {Document, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import * as React from 'react';

interface IComparisonColumns {
  received: number
  unread: number
}

interface IUserRow {
  timetoview: string
  [key: string]: string | IComparisonColumns
}

interface IProps {
  currentMonth: string
  previousMonth: string
  tableData: any
}

export const getUserActivityReportPdfExport = (props: IProps) => {
  const {currentMonth, previousMonth, tableData} = props;
  const usernames = Object.keys(tableData);
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: 'white',
      fontSize: 11,
      padding: '8mm'
    },
    pageTitle: {
      fontSize: 16,
      fontStyle: 'bold'
    },
    table: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap'
    },
    tableCell: {
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 1,
      borderBottomColor: '#00000033'
    },
    longTableCell: {
      maxWidth: '80mm',
      width: '80mm',
      padding: '2.5mm',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 1,
      borderBottomColor: '#00000033'
    },
  });
  const exportedPDF = () => (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        <View style={styles.pageTitle}>
          <Text>User Activity</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.longTableCell} />
          <View style={styles.tableCell}>
            <Text>Current Month</Text>
          </View>
          <View style={styles.tableCell} />
          <View style={styles.tableCell}>
            <Text>Previous Month</Text>
          </View>
          <View style={styles.tableCell} />
          <View style={styles.tableCell} />
        </View>
        <View style={styles.table}>
          <View style={styles.longTableCell}>
            <Text>User/Recipient</Text>
          </View>
          <View style={styles.tableCell}>
            <Text>Received</Text>
          </View>
          <View style={styles.tableCell}>
            <Text>Unread</Text>
          </View>
          <View style={styles.tableCell}>
            <Text>Received</Text>
          </View>
          <View style={styles.tableCell}>
            <Text>Unread</Text>
          </View>
          <View style={styles.tableCell}>
            <Text>Avg. Time to view</Text>
          </View>
        </View>
        {usernames.map((username, rowId) => {
          return(
            <View key={rowId} style={styles.table}>
              <View style={styles.longTableCell}>
                <Text>{username}</Text>
              </View>
              <View style={styles.tableCell}>
                <Text>{tableData[username][currentMonth].received}</Text>
              </View>
              <View style={styles.tableCell}>
                <Text>{tableData[username][currentMonth].unread}</Text>
              </View>
              <View style={styles.tableCell}>
                <Text>{tableData[username][previousMonth].received}</Text>
              </View>
              <View style={styles.tableCell}>
                <Text>{tableData[username][previousMonth].unread}</Text>
              </View>
              <View style={styles.tableCell}>
                <Text>{tableData[username].timetoview}</Text>
              </View>
            </View>
          )
        })}
      </Page>
    </Document>
  )
  return exportedPDF();
}
